var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"file"},[_c('img',{attrs:{"src":require("../assets/file-grey.svg"),"alt":""}}),_c('div',{staticClass:"data"},[_c('h4',{staticClass:"has-text-centered"},[_vm._v(_vm._s(_vm.name))])]),_c('a',{staticClass:"ml-1 is-small"},[_c('b-icon',{attrs:{"icon":"download"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }